// components/ForgotPassword.js
import React, { useState } from 'react';
//import axios from 'axios';
import menuLogo from "../assets/imagens/pentalobe.png";
import { Form, Button, Alert, Row, Col, Container } from 'react-bootstrap';
import api from '../redux/actions/configApi';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setMessage('');
        setLoading(true);

        try {
            const response = await api.post('forgot-password', { email });
           // console.log(response.data, 'response')
            setMessage(response.data.message || 'O link para redefinir sua senha foi enviado para seu email.');
        } catch (error) {
            // Handle error response from API
            if (error.response && error.response.data && error.response.data.message) {
                if (error.response.data?.message === "Please wait before retrying.") {
                    setError("Você fez muitas solicitações. Por favor, aguarde alguns minutos antes de tentar novamente.");
                } else {
                    setError(error.response.data?.message);
                }
            } else {
                console.error(error)
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container >
            <Row>
                <Col md={12} lg={12} >
                    <div className='d-flex justify-content-center align-items-center' style={{ height: '100vh' }}>
                        <Form onSubmit={handleSubmit} className="p-4 shadow-sm rounded bg-light" style={{ width: '50%' }}>
                            <Row>
                                <Col className="d-flex justify-content-center align-items-center m-3 flex-direction-row">
                                    <img className="logo-menu" src={menuLogo} alt="logo" style={{ width: '150px' }} />
                                </Col>
                            </Row>
                            <h5 className="text-center mb-4">Esqueceu a senha</h5>

                            {/* Show Success Message */}
                            {message && <Alert variant="success" className='text-center'>{message}</Alert>}

                            {/* Show Error Message */}
                            {error && <Alert variant="danger" className='text-center'>{error} </Alert>}

                            <Form.Group controlId="formEmail" >
                                <Form.Label>Email</Form.Label>
                                <Form.Control
                                    type="email"
                                    placeholder="Digite seu email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                    isInvalid={!!error}
                                />
                                <Form.Control.Feedback type="invalid">

                                </Form.Control.Feedback>
                            </Form.Group>

                            <div className="d-flex justify-content-center mt-3">
                                <Button type="submit" variant="primary" disabled={loading}>
                                    {loading ? 'Enviando...' : 'Enviar'}
                                </Button>
                            </div>
                        </Form>
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

export default ForgotPassword;
